import { render, staticRenderFns } from "./ModalProductOption.vue?vue&type=template&id=183b03b3&scoped=true"
import script from "./ModalProductOption.vue?vue&type=script&lang=js"
export * from "./ModalProductOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b03b3",
  null
  
)

export default component.exports